import { useAirlineLanding } from '../AirlineContext';

export default function SwArticle() {
  const { article } = useAirlineLanding();

  return (
    <article className="swp-article">
      <div className="swp-shell">
        <div className="swp-article__intro" id="swp-guide">
          <h2>{article.title}</h2>
          <p>{article.intro}</p>
        </div>

        {article.sections.map((section) => (
          <section key={section.id} id={section.id}>
            <h3>{section.heading}</h3>

            {section.paragraphs?.map((text) => (
              <p key={text.slice(0, 40)}>{text}</p>
            ))}

            {section.bullets ? (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item.slice(0, 40)}>{item}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </article>
  );
}
